import React from 'react';
import PropTypes from 'prop-types';
import { Container, Row, Col, Alert } from 'react-bootstrap';
import './DashboardErrorBoundary.css';

/**
 * Error Boundary component for Dashboard
 * Catches errors and displays a user-friendly error page
 */
class DashboardErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { 
            hasError: false, 
            error: null,
            errorInfo: null 
        };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true };
    }

    componentDidCatch(error, errorInfo) {
        this.setState({
            error: error,
            errorInfo: errorInfo
        });
        console.error('Dashboard Error:', error, errorInfo);
    }

    handleReset = () => {
        this.setState({ 
            hasError: false, 
            error: null,
            errorInfo: null 
        });
        // Optionally reload the dashboard
        window.location.reload();
    };

    render() {
        if (this.state.hasError) {
            return (
                <Container fluid className="dashboard-error-boundary">
                    <Row className="mt-5">
                        <Col md={8} lg={6} className="mx-auto">
                            <Alert variant="danger" className="dashboard-error-alert">
                                <Alert.Heading>⚠️ Dashboard Error</Alert.Heading>
                                <p>
                                    Something went wrong while loading the dashboard. 
                                    Please try again or contact support if the problem persists.
                                </p>
                                <hr />
                                <div className="dashboard-error-details">
                                    <p className="text-muted small mb-2">
                                        <strong>Error Details:</strong>
                                    </p>
                                    <pre className="dashboard-error-stack">
                                        {this.state.error?.toString()}
                                    </pre>
                                </div>
                                <div className="dashboard-error-actions mt-3">
                                    <button 
                                        className="btn btn-primary me-2"
                                        onClick={this.handleReset}
                                        aria-label="Reload dashboard"
                                    >
                                        🔄 Reload Dashboard
                                    </button>
                                    <button 
                                        className="btn btn-secondary"
                                        onClick={() => window.location.href = '/'}
                                        aria-label="Go to home page"
                                    >
                                        🏠 Go Home
                                    </button>
                                </div>
                            </Alert>
                        </Col>
                    </Row>
                </Container>
            );
        }

        return this.props.children;
    }
}

DashboardErrorBoundary.propTypes = {
    children: PropTypes.node,
};

export default DashboardErrorBoundary;
